import { Injectable } from "@angular/core";
import { WebAPICredential } from "@base/entities/BaseEntities";
import { APIGatewayService } from "../gateway/APIGateway.service";
import { BaseEndpointCRUD } from "@m4u-angular/base/endpoint/BaseEndpointCRUD";

@Injectable()
export class WebAPICredentialEndpoint extends BaseEndpointCRUD<WebAPICredential>
{
    //Constructor
    constructor(api: APIGatewayService) {
        super("WebAPICredential", api);
    }
}
